'use client'
import Link from 'next/link'
import s from './supplier-get-in-touch.module.scss'
import { LinkSVG } from '@/components/svg/link/link'
import { PhoneSVG } from '@/components/svg/phone/phone'
import { useState } from 'react'
import { PinterestIcon } from '@/components/svg/pinterest-icon/pinterest-icon'
import { FacebookIcon } from '@/components/svg/facebook-icon-new/facebook-icon'
import { InstagramIcon } from '@/components/svg/instagram-icon/instagram-icon'
import { GTM_EVENT, GTM_TRACKING_IDS } from '@/constants'
import { sendGTMEvent } from '@next/third-parties/google'

type Props = {
  facebookLink?: string | null
  instagramLink?: string | null
  pinterestLink?: string | null
  websiteLink?: string | null
  contactNumber?: string | null
}

export const SupplierGetInTouch = ({
  facebookLink,
  instagramLink,
  pinterestLink,
  websiteLink,
  contactNumber,
}: Props) => {
  const [showPhone, setShowPhone] = useState(false)
  const showButtonSection = !!(websiteLink || contactNumber)
  const showSocialSection = !!(facebookLink || instagramLink || pinterestLink)

  const handleShowPhone = () => {
    sendGTMEvent({
      event: GTM_EVENT.SUPPLIER_PHONE_SHOWN,
    })
    setShowPhone(true)
  }

  const handleSocialClick = (
    platform: 'instagram' | 'facebook' | 'pinterest'
  ) => {
    sendGTMEvent({
      event: GTM_EVENT.SOCIAL_CLICK_SUPPLIER_PROFILE,
      'social-type': platform,
    })
  }

  if (!showButtonSection && !showSocialSection) {
    return null
  }

  return (
    <section className={s.content}>
      {showButtonSection && (
        <div className={s.buttonsSection}>
          {websiteLink && (
            <Link
              href={websiteLink}
              target="_blank"
              className={s.button}
              id={GTM_TRACKING_IDS.SUPPLIER_CLICK_THROUGHS}
            >
              WEBSITE
              <LinkSVG svgProps={{ width: 16, height: 16 }} />
            </Link>
          )}

          {contactNumber &&
            (showPhone ? (
              <Link className={s.button} href={`tel:${contactNumber}`}>
                <PhoneSVG svgProps={{ width: 12, height: 12 }} />
                {contactNumber}
              </Link>
            ) : (
              <button className={s.button} onClick={handleShowPhone}>
                SHOW PHONE NUMBER
                <PhoneSVG svgProps={{ width: 12, height: 12 }} />
              </button>
            ))}
        </div>
      )}
      {showSocialSection && (
        <div className={s.socialButtons}>
          {pinterestLink && (
            <Link
              href={pinterestLink}
              target="_blank"
              onClick={() => handleSocialClick('pinterest')}
            >
              <PinterestIcon
                iconColor="#131313"
                svgProps={{ width: 20, height: 20 }}
              />
            </Link>
          )}
          {instagramLink && (
            <Link
              href={instagramLink}
              target="_blank"
              onClick={() => handleSocialClick('instagram')}
            >
              <InstagramIcon
                iconColor="#131313"
                svgProps={{ width: 20, height: 20 }}
              />
            </Link>
          )}
          {facebookLink && (
            <Link
              href={facebookLink}
              target="_blank"
              onClick={() => handleSocialClick('facebook')}
            >
              <FacebookIcon
                iconColor="#131313"
                svgProps={{ width: 20, height: 20 }}
              />
            </Link>
          )}
        </div>
      )}
    </section>
  )
}
